import { createSelector } from '@ngrx/store';

import { onlineOrderState } from '../root';

export const getOnlineOrderState = createSelector(onlineOrderState, (onlineOrder) => onlineOrder);
